export interface IItemBrandPricingComparative {
  average_price_micros: number;
  minimum_price_micros: number;
  comparison_history: IItemBrandPricingComparisonHistory[];
}

export interface IItemBrandPricingComparisonHistory {
  compared_at: string;
  average_price_micros: number;
  minimum_price_micros: number;
}

export interface IBrandsPricingComparative {
  id: number;
  name: string;
  log_maximum_price_micros: number;
  log_average_price_micros: number;
  log_minimum_price_micros: number;
  log_suppliers_count: number;
}
export interface IPricingComparative {
  id: number;
  name: string;
  log_default_brand_maximum_price_micros: number | null;
  log_default_brand_average_price_micros: number | null;
  log_default_brand_minimum_price_micros: number | null;
  log_maximum_price_micros: number;
  log_average_price_micros: number;
  log_minimum_price_micros: number;
  log_default_brand_suppliers_count: number;
  log_suppliers_count: number;
  brands: IBrandsPricingComparative[];
}

export const ChartDateFilterLabels = {
  SevenDays: 'Últimos 7 dias',
  ThirtyDays: 'Últimos 30 dias',
  ThreeMonths: 'Últimos 3 meses',
  SixMonths: 'Últimos 6 meses',
} as const;

export type ChartDateFilter =
  (typeof ChartDateFilterLabels)[keyof typeof ChartDateFilterLabels];

export interface IChartDateFilter {
  name: ChartDateFilter;
  valueInSeconds: number;
}
